/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Button as MuiButton, ButtonProps as MuiButtonProps } from "@mui/material";
import React from "react";

export type ButtonProps = MuiButtonProps;
export const Button = (props: ButtonProps) => {
  return (
    <MuiButton disableElevation {...props}>
      {props.children}
    </MuiButton>
  );
};
